module.exports = __webpack_public_path__ + "static/media/location-green.0addb74e.svg";